// Whether Send to kitchen prints the tickets (docs/plans/kitchen-tickets.md): the business sets
// it (`tenant_settings.kot_print`), and each device may choose otherwise with the arrow beside
// the button, kept here in localStorage (a waiter's phone and the counter tablet differ). Never
// synced. Offline on Counter the tickets always print, whatever is chosen.

export type SendPrint = 'print' | 'paper-free'
const KEY = 'ims.kot-send'

/** This device's choice, or null when it has none (the business setting then decides). */
export function readSendPrint(): SendPrint | null {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'print' || v === 'paper-free' ? v : null
  } catch {
    return null
  }
}

export function saveSendPrint(choice: SendPrint): void {
  try {
    localStorage.setItem(KEY, choice)
  } catch {
    // Storage blocked: the choice applies to this send only.
  }
}

/** Whether a send prints: this device's choice when it has one, else the business setting. */
export function printsOnSend(
  choice: SendPrint | null,
  settings: { kot_print?: boolean | null } | null | undefined,
): boolean {
  return choice ? choice === 'print' : !!settings?.kot_print
}
